const AUTH_URL = process.env.VUE_APP_AUTH_URL || "http://103.56.158.194:8003";
const BACKEND_URL = process.env.VUE_APP_BACKEND_URL || "http://103.56.158.194:8006";

export default {
  LOGIN: `${AUTH_URL}/login`,
  ACCOUNTS: `${AUTH_URL}/accounts`,
  CONFIGS: `${AUTH_URL}/dataconfigs`,
  ORGANIZATIONS: `${AUTH_URL}/organizations`,

  ROLES: `${BACKEND_URL}/roles`,
  ROLE_USERS: `${BACKEND_URL}/role-users`,

  CONTRACTS: `${BACKEND_URL}/contracts`,
  CONTRACT_STEPS: `${BACKEND_URL}/contract-steps`,
  CONTRACT_STATUS: `${BACKEND_URL}/contract-status`,
  CONTRACT_ACTIONS: `${BACKEND_URL}/contract-actions`,
};
